import { SELECT_DEALER } from 'constants/ActionTypes';
import { SEARCH } from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/guidelines/actionTypes';
import type { GuidelineFiltersState } from 'modules/guidelines/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const emptyState: GuidelineFiltersState = {
  [SEARCH]: null,
};

const filterAdapter = filterSliceAdapter(emptyState);

export default createReducer<GuidelineFiltersState>(filterAdapter.getInitialState(), {
  [types.SET_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.REMOVE_DASHBOARD_FILTER]: filterAdapter.removeFilter,
  [LOCATION_CHANGE]: filterAdapter.resetFilters,
  [SELECT_DEALER]: filterAdapter.resetFilters,
});
